import axios from 'axios';
import {HINTS_URL} from '../config/api';
import store from '../store';
import {getValidToken, authHeader} from './getValidToken';
import {isUnidentifiedCustomer as isUnidentifiedCustomerSelector} from '../selectors/configSelectors';
import {useKioskCustomer} from '../actions/login';

export async function getTaxes() {
  const address = store.getState().address;
  const currentAddress = address.deliveryAddresses[address.currentAddressIdx];
  if (!currentAddress) return new Promise((resolve, reject) => () => resolve(null));
  const data = {
    city: currentAddress.city,
    county: currentAddress.county,
    state: currentAddress.state
  };
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/tax`, data);
}
export async function clearTaxes() {
  const data = {
    city: '',
    county: '',
    state: ''
  };
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/tax`, data);
}

export async function getSummary(data, ticketType) {
  const token = await getValidToken();
  return axios.post(`${HINTS_URL}/HintsService/v1.0/rest/ecommerce/mastercalc/tickettype/${ticketType}`, data, authHeader(token));
}



// WEBPACK FOOTER //
// ./src/services/taxes.js